import ForgetPassword from "@/pages/auth/forgetPassword";
import { createFileRoute } from "@tanstack/react-router";

type ForgetPasswordRouteSearch = {
	token?: string;
};

export const Route = createFileRoute("/_login/forgetPassword")({
	component: RouteComponent,
	validateSearch: (
		search: Record<string, unknown>,
	): ForgetPasswordRouteSearch => ({
		token:
			typeof search.token === "string" && search.token.trim().length > 0
				? search.token
				: undefined,
	}),
});

function RouteComponent() {
	const { token } = Route.useSearch();
	return <ForgetPassword token={token} />;
}
